import { Typography } from '@progress/kendo-react-common';

import { Button } from '@progress/kendo-react-buttons';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { Spinner } from '../loader/Spinner';
import { Card, CardBody, CardFooter, CardHeader } from '@progress/kendo-react-layout';

import { DATE_FORMAT } from '../../constants';
import { FilterParent } from '../../models/filter.model';
import { formatAppDate } from '../../hooks/utils';
import { INTERACTIONS_ROUTES } from 'routes/routes.const';

const INTERACTION_URL = INTERACTIONS_ROUTES.root;

interface InteractionData {
  date: string;
  topics: string[];
  products: string[];
  channel: string;
  profile: string;
  fieldTeam: string;
}

export default function InteractionTab({
  data,
  isLoading,
  navigate,
  HeaderComponent,
  isTeamMember,
}: any) {
  if (isLoading) {
    return <Spinner />;
  }
  if (data.data.length === 0) {
    return (
      <div className="no-data">
        <KwelloSvgIcon icon={KWELLO_ICON.INFO_ROUNDED_ICON} />
        <Typography.p>No Interaction History</Typography.p>
      </div>
    );
  }

  return (
    <div className="interaction-tab">
      {HeaderComponent}
      <div className="tab-content">
        {data.data.map((row: InteractionData, index: number) => {
          const name = isTeamMember ? row.profile : row.fieldTeam;
          return (
            <Card key={`${row.profile}-${index}`}>
              <CardHeader>
                <Typography.h6>{row.channel}</Typography.h6>
              </CardHeader>
              <CardBody>
                <div className="flex-column" style={{ marginTop: 16 }}>
                  <div
                    className="flex-row"
                    style={{
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <Typography.p>Topic</Typography.p>
                    </div>
                    <div>
                      <Typography.p fontWeight="bold">{row.topics.toString()}</Typography.p>
                    </div>
                  </div>
                  <div
                    className="flex-row"
                    style={{
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <Typography.p>Material</Typography.p>
                    </div>
                    <div>
                      <Typography.p fontWeight="bold">{row.products.toString()}</Typography.p>
                    </div>
                  </div>
                </div>
              </CardBody>
              <CardFooter>
                <div className="date">
                  <KwelloSvgIcon icon={KWELLO_ICON.CALENDAR_ICON} />
                  {formatAppDate(row.date, DATE_FORMAT)}
                </div>
                {new Date(row.date).getHours() > 0 && (
                  <div className="time">
                    <KwelloSvgIcon icon={KWELLO_ICON.TIMER_ICON} />
                    {row.date.substring(row.date.lastIndexOf('T') + 1)}
                  </div>
                )}
                <div className="time">
                  <KwelloSvgIcon icon={KWELLO_ICON.LIGHT_BULB_ICON} /> {name}
                </div>
              </CardFooter>
            </Card>
          );
        })}
      </div>
      <div className="panel-footer">
        {/* eslint-disable-next-line @typescript-eslint/no-unsafe-return */}
        <Button
          rounded={'full'}
          onClick={(): void => {
            navigate(INTERACTION_URL, true, FilterParent.INTERACTION);
          }}
        >
          View all Interactions <KwelloSvgIcon icon={KWELLO_ICON.FILE_FIND} />
        </Button>
      </div>
    </div>
  );
}
